import { memo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzHeading } from '../../../components';

const FundOverview = ({ fundOverview }) => {


    return (
        <>
            <Container fluid className='p-0 bdr-top'>
                <Row className='g-0 py-4'>
                    <Col>
                        <BzHeading className='font-medium font-size5 color-text'>Fund Overview</BzHeading>
                    </Col>
                </Row>
                <Row className='g-0'>
                    <Col>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>CAGR</div>
                            </Col>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size3 color-text color-positive'>{fundOverview?.cagr}<span className='font-regular font-size3 color-text ms-1'>(3Y)</span></div>
                                <div className='icon-16 icon-sort-down icon-dark ms-1'></div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Risk</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text color-negative'>{fundOverview?.risk}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Minimum Investment</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.minimumInvestment}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>AUM</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.aum}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Expense Ratio</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.expenseRatio}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Exit Load</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.exitLoad}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Lock-in Priod</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.lockInPriod}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>AMC Name</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.amcName}</div>
                            </Col>
                        </Row>
                    </Col>

                    <Col md={1}>&nbsp;</Col>

                    <Col>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Scheme Name</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.schemeName}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Exchange Scheme Code</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.exchangeSchemeCode}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Scheme Category</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.schemeCategory}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Face Value</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.faceValue}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Transaction Type Allowed</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>&nbsp;</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Scheme Launch Date</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.schemeLaunchDate}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 pb-3'>
                            <Col md={5}>
                                <div className='font-regular font-size2 color-subtext'>Fund Manager</div>
                            </Col>
                            <Col>
                                <div className='font-regular font-size3 color-text'>{fundOverview?.fundManager}</div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </Container>
        </>
    );
};

export default memo(FundOverview);